/** Normalize paths so trailing slashes match Gatsby-style links. */
export function normalizePath(to: string): string {
  if (!to || to === '/') return '/';
  return to.replace(/\/+$/, '') || '/';
}
